import styled from "styled-components";

export const FreeShippingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 8px;
`;

export const FreeShippingText = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${props =>
    props.atingiu ? props.theme.colors.primary : props.theme.colors.neutral900};
`;

export const FreeShippingBar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: ${props => props.theme.colors.neutral100};
  overflow: hidden;
`;

export const FreeShippingBarFill = styled.div`
  height: 100%;
  width: ${props => props.percentual}%;
  border-radius: 3px;
  background: ${props =>
    props.atingiu ? props.theme.colors.primary : props.theme.colors.neutral900};
  transition: width 0.3s;
`;
